import React from "react";
import SuspenseWrapper from "@/router/component/SuspenseWrapper";
const DocumentCenter = React.lazy(() => import("@/pages/policy/Index"));

const Policy = [
  {
    path: "policy",
    element: (
      <SuspenseWrapper>
        <DocumentCenter />
      </SuspenseWrapper>
    ),
  },
  {},
];

export default Policy;
